import { TitleCell, TitleRow } from '../../../components/ReusableComponents/Table'

const BillingTitleRow = () => (
  <TitleRow style={{ position: 'sticky', top: 70 }}>
    <TitleCell>To</TitleCell>
    <TitleCell>Send on</TitleCell>
    <TitleCell>Subject</TitleCell>
    <TitleCell>Events</TitleCell>
    <TitleCell>View</TitleCell>
  </TitleRow>
)

export default BillingTitleRow
